import React, { lazy, Suspense } from "react";

const LazyPropertyReport = lazy(() => import("./PropertyReport"));
const LazyRequiredReport = lazy(() => import("./RequiredReport"));

export const PropertyReport = () => (
  <Suspense fallback="loading...">
    <LazyPropertyReport />
  </Suspense>
);
export const RequiredReport = () => (
  <Suspense fallback="loading...">
    <LazyRequiredReport />
  </Suspense>
);
